import { useEffect, useState } from "react";

export const useOnScreen = (ref: any, rootMargin = 0) => {
  const [state, setState] = useState<[boolean, "above" | "below"]>([
    false,
    "above",
  ]);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const position = entry.boundingClientRect.top < 0 ? "above" : "below";

        setState([entry.isIntersecting, position]);
      },
      {
        rootMargin: `${rootMargin}px`,
      }
    );
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, []);
  return state;
};
